// @mui material components
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// OrderDetails page components
import Header from 'layouts/purchases/pages/singleLead/Sections/Main/order-details/components/Header';
import OrderInfo from 'layouts/purchases/pages/singleLead/Sections/Main/order-details/components/OrderInfo';
import BillingInformation from 'layouts/purchases/pages/singleLead/Sections/Main/order-details/components/BillingInformation';
import ShippingInformation from 'layouts/purchases/pages/singleLead/Sections/Main/order-details/components/ShippingInformation';
import OrderSummary from 'layouts/purchases/pages/singleLead/Sections/Main/order-details/components/OrderSummary';

// Shared print template
import { printShippingLabel } from 'layouts/purchases/helpers/printTemplate';

function OrderDetails({ wooCommerceOrderDetails }) {
    // Prop kontrolü
    if (!wooCommerceOrderDetails) {
        return (
            <MDBox textAlign="center" py={3}>
                <MDTypography variant="h6" color="text">
                    WooCommerce sipariş detayları yükleniyor...
                </MDTypography>
            </MDBox>
        );
    }

    // Gerekli alanların kontrolü
    const orderNumber = wooCommerceOrderDetails.number || 'N/A';
    const orderDate = wooCommerceOrderDetails.date_created || new Date().toISOString();
    const billing = wooCommerceOrderDetails.billing || {};
    const customerName = `${billing.first_name || ''} ${billing.last_name || ''}`.trim() || 'Müşteri Adı Belirtilmemiş';

    // Fiyat formatlama fonksiyonu
    const formatPrice = (price) => {
        try {
            const numericPrice = parseFloat(price) || 0;
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
            }).format(numericPrice);
        } catch (error) {
            console.warn('Fiyat formatlama hatası:', error);
            return '0,00 ₺';
        }
    };

    // Yazdır fonksiyonu
    const handlePrint = () => {
        printShippingLabel(wooCommerceOrderDetails);
    };

    return (
        <MDBox>
            <Grid
                container
                spacing={3}
                sx={{
                    justifyContent: 'center',
                }}
            >
                <Grid
                    size={{
                        xs: 12,
                        lg: 12,
                    }}
                >
                    <Card>
                        <MDBox pt={2} px={2}>
                            <Header
                                orderNumber={orderNumber}
                                orderDate={orderDate}
                                customerName={customerName}
                                onPrint={handlePrint}
                            />
                        </MDBox>
                        <Divider />
                        <MDBox pt={1} pb={3} px={2}>
                            <MDBox mb={3}>
                                <OrderInfo line_items={wooCommerceOrderDetails.line_items} />
                            </MDBox>
                            <Divider />
                            <MDBox mt={3}>
                                <Grid container spacing={3} sx={{ alignItems: 'flex-start' }}>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 6,
                                            lg: 4,
                                        }}
                                    >
                                        <BillingInformation billing={billing} />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 6,
                                            lg: 4,
                                        }}
                                    >
                                        <ShippingInformation shipping={wooCommerceOrderDetails.shipping || {}} />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 4,
                                        }}
                                    >
                                        <OrderSummary
                                            discountTotal={wooCommerceOrderDetails.discount_total || '0'}
                                            discountTax={wooCommerceOrderDetails.discount_tax || '0'}
                                            shipping={wooCommerceOrderDetails.shipping_total || '0'}
                                            shippingTax={wooCommerceOrderDetails.shipping_tax || '0'}
                                            cartTax={wooCommerceOrderDetails.cart_tax || '0'}
                                            total={wooCommerceOrderDetails.total || '0'}
                                            totalTax={wooCommerceOrderDetails.total_tax || '0'}
                                            pricesIncludeTax={wooCommerceOrderDetails.prices_include_tax || false}
                                            payment_method={wooCommerceOrderDetails.payment_method || ''}
                                            payment_method_title={
                                                wooCommerceOrderDetails.payment_method_title || 'Belirtilmemiş'
                                            }
                                            shipping_lines={wooCommerceOrderDetails?.shipping_lines || []}
                                        />
                                    </Grid>
                                </Grid>
                            </MDBox>
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default OrderDetails;
